import { AddressInterface } from 'common/address.interface';
import { ProfileInterface } from '../profiles/types';
import { StopInterface } from '../stops/types';

/*
 * Action Types
 */
export enum TollTypes {
  LIST_TOLLS_REQUEST = '@toll/LIST_TOLLS_REQUEST',
  LIST_TOLLS_SUCCESS = '@toll/LIST_TOLLS_SUCCESS',
  LIST_TOLLS_FAILURE = '@toll/LIST_TOLLS_FAILURE',

  GET_TOLL_REQUEST = '@toll/GET_TOLL_REQUEST',
  GET_TOLL_SUCCESS = '@toll/GET_TOLL_SUCCESS',
  GET_TOLL_FAILURE = '@toll/GET_TOLL_FAILURE',

  FILTER_TOLLS_REQUEST = '@toll/FILTER_TOLLS_REQUEST',
  FILTER_TOLLS_SUCCESS = '@toll/FILTER_TOLLS_SUCCESS',
  FILTER_TOLLS_FAILURE = '@toll/FILTER_TOLLS_FAILURE',

  CREATE_TOLL_REQUEST = '@toll/CREATE_TOLL_REQUEST',
  CREATE_TOLL_SUCCESS = '@toll/CREATE_TOLL_SUCCESS',
  CREATE_TOLL_FAILURE = '@toll/CREATE_TOLL_FAILURE',

  UPDATE_TOLL_REQUEST = '@toll/UPDATE_TOLL_REQUEST',
  UPDATE_TOLL_SUCCESS = '@toll/UPDATE_TOLL_SUCCESS',
  UPDATE_TOLL_FAILURE = '@toll/UPDATE_TOLL_FAILURE',

  DELETE_TOLL_REQUEST = '@toll/DELETE_TOLL_REQUEST',
  DELETE_TOLL_SUCCESS = '@toll/DELETE_TOLL_SUCCESS',
  DELETE_TOLL_FAILURE = '@toll/DELETE_TOLL_FAILURE',
}

/*
 * Data types
 */

export interface TollUpdateRequest {
  id: string;
  data: string;
  description: string;
  validFrom: Date;
  updated: boolean;
  createdAt: Date;
  updatedAt: Date;
  tollId: string;
}
export interface TollProfile {
  Profile: ProfileInterface;
  createdAt: string;
  id: string;
  profileId: string;
  tollId: string;
  updatedAt: string;
  value: number;
}

export interface TollInterface {
  id: string;
  name: string;
  value: number;
  place?: string;
  createdAt: string;
  updatedAt: string;
  stopId: string;
  transportOperatorId: string;
  TollProfiles?: TollProfile[];
  Stop?: StopInterface & {
    Address: AddressInterface & {
      latitude: string | null;
      longitude: string | null;
    };
  };
  LineSections?: any[];
  TollUpdateRequests?: TollUpdateRequest[];
}

/*
 * State type
 */
export interface TollState {
  readonly tollsList: TollInterface[];
  readonly tollData: TollInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
